module.exports = __webpack_public_path__ + "img/Metadata.01bf1816.gif";